import axiosInstance from "./AxiosInstance";

class UserService {
  createUser(userData) {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const organizationId = userDetails?.user?.organizationId;
    if (!organizationId) {
      throw new Error("Organization ID not found");
    }
    return axiosInstance.post(`/v1/organization/${organizationId}/user`, userData);
  }

  validateEmployeeEmail(email) {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const organizationId = userDetails?.user?.organizationId;
    if (!organizationId) {
      throw new Error("Organization ID not found");
    }
    return axiosInstance.post(
      `/v1/organization/${organizationId}/user/validate-email`,
      { email }
    );
  }

  getUsers(filters = {}) {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const organizationId = userDetails?.user?.organizationId;
    if (!organizationId) {
      throw new Error("Organization ID not found");
    }
    const {
      page = 1,
      limit = 10,
      search = '',
      role = '',
      skills = [],
      availability,
      categories,
      employees,
      customers,
      jobStatus,
      tasks,
      startDate,
      endDate,
      archived = false
    } = filters;

    const params = {
      skip: (page - 1) * limit,
      limit
    };

    // Add optional filters
    if (search) params.search = search;
    if (role) params.role = role;
    if (skills.length > 0) params['skills[]'] = skills;
    if (availability !== undefined) params.availability = availability;
    if (categories) params.categories = categories;
    if (employees) params.employees = employees;
    if (customers) params.customers = customers;
    if (jobStatus) params.jobStatus = jobStatus;
    if (tasks) params.tasks = tasks;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (archived) params.archived = true;

    return axiosInstance.get(`/v1/organization/${organizationId}/user`, { params });
  }

  getUserById(userId) {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const organizationId = userDetails?.user?.organizationId;
    if (!organizationId) {
      throw new Error("Organization ID not found");
    }
    return axiosInstance.get(`/v1/organization/${organizationId}/user/${userId}`);
  }

  updateUser(userId, userData) {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const organizationId = userDetails?.user?.organizationId;
    if (!organizationId) {
      throw new Error("Organization ID not found");
    }
    return axiosInstance.put(`/v1/organization/${organizationId}/user/${userId}`, userData);
  }

  activateUser(userId, organizationId) {
    const orgId = organizationId || JSON.parse(localStorage.getItem("userDetails") || "{}")?.user?.organizationId;
    if (!orgId) throw new Error("Organization ID not found");
    return axiosInstance.patch(`/v1/organization/${orgId}/user/${userId}/activate`);
  }

  deactivateUser(userId, organizationId) {
    const orgId = organizationId || JSON.parse(localStorage.getItem("userDetails") || "{}")?.user?.organizationId;
    if (!orgId) throw new Error("Organization ID not found");
    return axiosInstance.patch(`/v1/organization/${orgId}/user/${userId}/deactivate`);
  }

  archiveUser(userId, isArchived = true) {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const organizationId = userDetails?.user?.organizationId;
    if (!organizationId) {
      throw new Error("Organization ID not found");
    }
    return axiosInstance.patch(`/v1/organization/${organizationId}/user/${userId}/archive`, {
      isArchived
    });
  }
}

export default new UserService(); 